import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations/index.ts";

import {
    SectionHeader as BaseSectionHeader,
    SectionHeaderCell
} from "../atoms";

export interface SectionHeaderProps {
    sectionTitle: string;
    totalColumnCount: number;
}

export const SectionHeader = (props: SectionHeaderProps) => {
    const { sectionTitle, totalColumnCount } = props;
    return (
        <BaseSectionHeader>
            <SectionHeaderCell>
                <span css={sectionHeaderSpanCss}>{sectionTitle}</span>
            </SectionHeaderCell>

            <>
                {Array(totalColumnCount - 1)
                    .fill("")
                    .map((_, idx) => (
                        <SectionHeaderCell key={idx} />
                    ))}
            </>
        </BaseSectionHeader>
    );
};

const sectionHeaderSpanCss = css({
    color: wacToken("color.primary.black"),
    width: "100%",
    fontWeight: "bold",
    height: "auto",
    display: "block",
    overflowWrap: "break-word"
});
